/**
 * Predefined (built-in) workflow templates.
 * These render inside the "Comienza tu workflow" grid alongside user-saved templates.
 *
 * When a user clicks one, POST /api/projects/templates/instantiate is called
 * with {name, nodes, edges, node_id_counter} — creating a real project.
 */
import { Sparkles, Video, Film } from 'lucide-react';

const EDGE_STYLE = { stroke: '#10b981', strokeWidth: 2 };

const mkEdge = (n, source, target) => ({
  id: `edge_${source}_${target}`,
  source, target,
  sourceHandle: 'output',
  targetHandle: 'input',
  animated: true,
  style: EDGE_STYLE,
});

const ENHANCE_NODES = [
  { id: 'node_1', type: 'uploadImage',      position: { x: 100, y: 200 }, data: { nodeId: 'node_1' } },
  { id: 'node_2', type: 'imageEnhancement', position: { x: 420, y: 200 }, data: { nodeId: 'node_2' } },
  { id: 'node_3', type: 'outputPreview',    position: { x: 740, y: 200 }, data: { nodeId: 'node_3' } },
];
const ENHANCE_EDGES = [mkEdge(1, 'node_1', 'node_2'), mkEdge(2, 'node_2', 'node_3')];

const VIDEO_NODES = [
  { id: 'node_1', type: 'uploadImage',     position: { x: 100, y: 200 }, data: { nodeId: 'node_1' } },
  { id: 'node_2', type: 'videoGeneration', position: { x: 420, y: 200 }, data: { nodeId: 'node_2' } },
  { id: 'node_3', type: 'outputPreview',   position: { x: 740, y: 200 }, data: { nodeId: 'node_3' } },
];
const VIDEO_EDGES = [mkEdge(1, 'node_1', 'node_2'), mkEdge(2, 'node_2', 'node_3')];

const VIDEO_FLOW_NODES = [
  { id: 'node_1', type: 'uploadVideo',     position: { x: 60,   y: 200 }, data: { nodeId: 'node_1' } },
  { id: 'node_2', type: 'frameExtractor',  position: { x: 360,  y: 120 }, data: { nodeId: 'node_2' } },
  { id: 'node_3', type: 'videoGeneration', position: { x: 660,  y: 200 }, data: { nodeId: 'node_3' } },
  { id: 'node_4', type: 'frameExtractor',  position: { x: 960,  y: 120 }, data: { nodeId: 'node_4' } },
  { id: 'node_5', type: 'outputPreview',   position: { x: 1260, y: 200 }, data: { nodeId: 'node_5' } },
];
const VIDEO_FLOW_EDGES = [
  mkEdge(1, 'node_1', 'node_2'),
  mkEdge(2, 'node_2', 'node_3'),
  mkEdge(3, 'node_3', 'node_4'),
  mkEdge(4, 'node_4', 'node_5'),
];

export const PREDEFINED_TEMPLATES = [
  {
    id: 'predef-enhance',
    predefined: true,
    name: 'Mejorar Imagen',
    description: 'Upload → Enhancement → Preview',
    icon: Sparkles,
    accent: '#10b981',
    nodes: ENHANCE_NODES,
    edges: ENHANCE_EDGES,
    node_id_counter: 4,
  },
  {
    id: 'predef-video',
    predefined: true,
    name: 'Crear Video',
    description: 'Upload → Video Gen → Preview',
    icon: Video,
    accent: '#8b5cf6',
    nodes: VIDEO_NODES,
    edges: VIDEO_EDGES,
    node_id_counter: 4,
  },
  {
    id: 'predef-videoflow',
    predefined: true,
    name: 'Video Flow',
    description: 'Video → Frame → Video Gen → Frame → Preview',
    icon: Film,
    accent: '#06b6d4',
    nodes: VIDEO_FLOW_NODES,
    edges: VIDEO_FLOW_EDGES,
    node_id_counter: 6,
  },
];
